import React from "react";
import { Stack, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import GradientBox from "../../components/patterns/color/GradientBox";

/**
 * MagazineFooterBanner
 * My Threads Insight 구경하기 배너
 * @param {object} props
 * @param {boolean} [props.isMobile]
 */
const MagazineFooterBanner = ({ isMobile }) => {
	const theme = useTheme();
	const navigate = useNavigate();
	const { t } = useTranslation();

	return (
		<GradientBox
			palette={["#1A252F", "#3F4B56"]}
			type="linear"
			contrast="ambient"
			noise={true}
			noiseColor="#000000"
			noiseType="medium"
			angle={135}
			animated={true}
			animationDuration={10}
			sx={{
				width: "100%",
				py: isMobile ? 4 : 6,
				px: isMobile ? 2 : 4,
				textAlign: "center",
				borderRadius: isMobile ? 4 : 8,
			}}
		>
			<Stack
				spacing={isMobile ? 2 : 3}
				alignItems="center"
				sx={{ maxWidth: 600, mx: "auto" }}
			>
				<Typography
					variant={isMobile ? "h6" : "h4"}
					sx={{
						fontFamily:
							'"source-han-serif-korean", "Noto Serif KR", "Noto Serif CJK KR", "Source Han Serif KR", "Apple SD Gothic Neo", "Malgun Gothic", "맑은 고딕", serif',
						fontWeight: 900,
						color: theme.palette.background.paper,
						wordBreak: "keep-all",
					}}
				>
					{t("magazine.footerBanner.title")}
				</Typography>
				<Typography
					variant={isMobile ? "body2" : "body1"}
					sx={{
						color: theme.palette.background.paper,
						opacity: 0.9,
						wordBreak: "keep-all",
						lineHeight: 1.6,
					}}
				>
					{t("magazine.footerBanner.description")}
				</Typography>
				<Button
					variant="contained"
					size={isMobile ? "medium" : "large"}
					onClick={() => navigate("/")}
					sx={{
						backgroundColor: theme.palette.background.paper,
						color: theme.palette.primary.main,
						fontWeight: 700,
						fontSize: isMobile ? "14px" : "16px",
						px: isMobile ? 3 : 4,
						py: isMobile ? 1 : 1.5,
						"&:hover": {
							backgroundColor: theme.palette.background.paper,
							opacity: 0.9,
						},
					}}
				>
					{t("magazine.footerBanner.button")}
				</Button>
			</Stack>
		</GradientBox>
	);
};

export default MagazineFooterBanner;